import { IndicatorCloseController, getIndicatorCloseDelay } from "../indicator/lifecycle.js";
import { DEFAULT_STATUS_ANNOUNCER_LABELS } from "./labels.js";
import { deriveStatusAnnouncement, deriveVolumeAnnouncement } from "./status.js";
import { createState } from "@videojs/store";
//#region src/core/ui/status-announcer/core.ts
const ANNOUNCEMENT_DEBOUNCE = 200;
var StatusAnnouncerCore = class {
	state = createState({
		generation: 0,
		label: null
	});
	#props = {};
	#snapshot = null;
	#seekStartTime = null;
	#seekTargetTime = null;
	#timer = null;
	#close = new IndicatorCloseController(() => this.state.patch({ label: null }), () => getIndicatorCloseDelay(this.#props));
	setProps(props) {
		this.#props = props;
	}
	resetSnapshot() {
		this.#snapshot = null;
		this.#seekStartTime = null;
		this.#seekTargetTime = null;
		this.#clearTimer();
		this.#close.close();
	}
	destroy() {
		this.#clearTimer();
		this.#close.destroy();
	}
	processSnapshot(snapshot) {
		const previous = this.#snapshot;
		this.#snapshot = snapshot;
		if (!previous) return false;
		const labels = this.#getLabels();
		const statusLabel = deriveStatusAnnouncement(previous, snapshot, labels);
		const statusHandled = statusLabel !== null && this.#announce(statusLabel);
		const seekHandled = this.#processSeekSnapshot(previous, snapshot, labels, statusHandled);
		const volumeHandled = this.#processVolumeSnapshot(previous, snapshot, labels, statusHandled || seekHandled);
		return statusHandled || seekHandled || volumeHandled;
	}
	#getLabels() {
		return {
			...DEFAULT_STATUS_ANNOUNCER_LABELS,
			...this.#props.labels
		};
	}
	#announce(label) {
		this.#clearTimer();
		this.state.patch({
			generation: this.state.current.generation + 1,
			label
		});
		this.#close.arm();
		return true;
	}
	#processVolumeSnapshot(previous, snapshot, labels, alreadyHandled) {
		const label = deriveVolumeAnnouncement(previous, snapshot, labels);
		if (label === null || alreadyHandled || !this.#shouldAnnounce()) return false;
		this.#schedule(label);
		return true;
	}
	#processSeekSnapshot(previous, snapshot, labels, alreadyHandled) {
		if (previous.seeking !== true && snapshot.seeking === true) {
			this.#seekStartTime = previous.currentTime ?? null;
			this.#seekTargetTime = snapshot.currentTime ?? null;
			this.#clearTimer();
			return false;
		}
		if (snapshot.seeking === true) {
			this.#seekTargetTime = snapshot.currentTime ?? this.#seekTargetTime;
			return false;
		}
		if (previous.seeking !== true || snapshot.seeking !== false) return false;
		const targetTime = snapshot.currentTime ?? this.#seekTargetTime;
		const startTime = this.#seekStartTime;
		this.#seekStartTime = null;
		this.#seekTargetTime = null;
		if (targetTime === void 0 || targetTime === null || Object.is(targetTime, startTime)) return false;
		if (alreadyHandled || !this.#shouldAnnounce()) return false;
		this.#schedule(labels.seekedTo(targetTime));
		return true;
	}
	#schedule(label) {
		this.#clearTimer();
		this.#timer = setTimeout(() => {
			this.#timer = null;
			if (!this.#shouldAnnounce()) return;
			this.#announce(label);
		}, ANNOUNCEMENT_DEBOUNCE);
	}
	#shouldAnnounce() {
		return this.#props.shouldAnnounce?.() !== false;
	}
	#clearTimer() {
		if (this.#timer === null) return;
		clearTimeout(this.#timer);
		this.#timer = null;
	}
};
//#endregion
export { StatusAnnouncerCore };

//# sourceMappingURL=core.js.map